<template>
  <div class="wizzard__form">
    <Flows
      :flows="distributions"
      :restrictions="DISTRIBUTION_TYPES"
      @submit="handleSubmit"
      @remove="handleRemove"
    />
  </div>
</template>

<script setup lang="ts">
import { TransactionClass } from '@types'

import { DISTRIBUTION_TYPES } from './utils/const'

import Flows from './components/Flows.vue'

const distributions = defineModel<TransactionClass[]>('distributions', {
  required: true,
})

defineOptions({ inheritAttrs: false })

const handleSubmit = (data: TransactionClass) => {
  distributions.value?.push(data)
}

const handleRemove = (index: number) => {
  distributions.value?.splice(index, 1)
}
</script>
